module.exports = __webpack_public_path__ + "static/media/raven_sad_11.81918a0b.svg";